"use client";

import React from "react";
import { useRouter } from "next/navigation";
import { useApp } from "./AppProvider";

interface RequestCTAProps {
  title: string;
  slug: string;
}

export default function RequestCTA({ title, slug }: RequestCTAProps) {
  const { isRTL } = useApp();
  const router = useRouter();

  const handleRequest = () => {
    router.push(`/get-quote?ref=${slug}&title=${encodeURIComponent(title)}`);
  };

  return (
    <div
      style={{
        position: "fixed",
        top: "50%",
        [isRTL ? "left" : "right"]: "0",
        transform: "translateY(-50%)",
        zIndex: 100,
      }}
    >
      <button
        onClick={handleRequest}
        style={{
          background: "var(--gradient-brand)",
          color: "white",
          padding: "1rem 1.5rem",
          border: "none",
          borderRadius: isRTL ? "0 12px 12px 0" : "12px 0 0 12px",
          cursor: "pointer",
          boxShadow: "0 10px 30px rgba(227,1,125,0.4)",
          fontWeight: 700,
          fontSize: "0.9rem",
          letterSpacing: "0.02em",
          writingMode: "vertical-rl",
          textOrientation: "mixed",
          display: "flex",
          alignItems: "center",
          gap: "0.5rem",
          transition: "all 0.3s ease",
        }}
        onMouseEnter={(e) => {
          (e.currentTarget as HTMLButtonElement).style.transform = isRTL ? "translateX(10px)" : "translateX(-10px)";
        }}
        onMouseLeave={(e) => {
          (e.currentTarget as HTMLButtonElement).style.transform = "translateX(0)";
        }}
      >
        <span style={{ fontSize: "1.2rem" }}>🛎️</span>
        {isRTL ? "اطلب الخدمة الآن" : `Request ${title} Now`}
      </button>
    </div>
  );
}
